import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import "./EditGuardCompanies/EditGuardCompaniesComponent";
import "./GuardCompanies.html";

import GuardCompaniesComponentController from "./GuardCompaniesComponentController";

export default class GuardCompaniesComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            site: "<",
        };
        this.controller = GuardCompaniesComponentController;
        this.templateUrl = "/App/Components/Site/Overview/GuardCompanies/GuardCompanies.html";
    }
}

module("mmManagePortal").component("mmSiteGuardCompanies", new GuardCompaniesComponent());
